import axios from "axios";
import { Manager } from "../../types/model/user";
import { SessionStore } from "../../types/store/SessionStore";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/project/managers`;

export const listManagers = async (
  accountId: number,
  projectId?: number,
  activityId?: number,
  procedureId?: number,
): Promise<Manager[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  return await axios
    .get<Manager[]>(BASE_URL, {
      params: {
        accountId,
        projectId,
        activityId,
        procedureId,
      },
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            )
          : AbortSignal.timeout(
              Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
            ),
    })
    .then((response) => response.data)
    .catch((error) => {
      console.error("Erro ao buscar projetos:", error);
      return [];
    });
};
